import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../core/useAuth';
import { displayNameFromToken } from '../core/decodeToken';

/*
 * Topbar entry to the user page, labelled with the logged-in subject
 * (full name, else login id) instead of a generic "user" — that is the
 * one place telling you *who* you are working as. Falls back to the
 * generic label while no token is decoded yet.
 *
 * The person icon in front of the name comes from `.topbar-user` in
 * theme.css. On phones the topbar drops the labels (`font-size: 0`)
 * and only that icon remains — so the name simply disappears there,
 * no extra handling needed.
 */
export function CurrentUserLink() {
  const { t } = useTranslation();
  const { token } = useAuth();

  const name = displayNameFromToken(token);

  return (
    <Link
      className="topbar-link topbar-user"
      to="/dashboard/user"
      title={name ?? undefined}
    >
      {name ?? t('topbar.user')}
    </Link>
  );
}
